import { Component } from 'react';

import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import styles from './PaymentMethodAuthenticationModal.module.css';
import { LoadingSpinner } from '../../ui/loadingSpinner';

export class PaymentMethodAuthenticationModal extends Component<{
    authenticationIframeURL: string;
}> {
    state = { authenticationIframeLoaded: false };

    checkAuthenticationIframeLoaded = () => {
        this.setState({ authenticationIframeLoaded: true });
    };

    render() {
        const { authenticationIframeURL } = this.props;
        const iframeLoadedStyles = this.state.authenticationIframeLoaded
            ? styles.authenticationIframeLoaded
            : null;
        const iframeStyles = classNames(
            styles.authenticationIframe,
            iframeLoadedStyles
        );

        return (
            <>
                <div className={styles.title}>
                    <FormattedMessage
                        id="_.processing_payment.modal.requires_authentication_title"
                        defaultMessage="A quick security check"
                    />
                </div>
                {!this.state.authenticationIframeLoaded && (
                    <LoadingSpinner
                        className={styles.authenticationIframeLoadingSpinner}
                    />
                )}
                <iframe
                    title="authentication"
                    className={iframeStyles}
                    src={authenticationIframeURL}
                    onLoad={this.checkAuthenticationIframeLoaded}
                />
            </>
        );
    }
}
